module.exports = __webpack_public_path__ + "static/img/data-icon.30ff5725.gif";